import React, { useContext, useEffect, useState } from "react";
import { launchableContextDefaultValues } from "tests/defaultValues";
import agent, { LaunchableFromList } from "server";
import { OrgContext } from "./OrgContext";
import { toast } from "utils/toast";
import { AxiosRes, BaseRes } from "server/config";

interface ILaunchableContext {
  activelaunchables: LaunchableFromList[];
  loadingActiveLaunchables: boolean;
  refreshActiveLaunchables: () => any;
  deleteLaunchable: (orgID: string, id: string) => any;
}

export const LaunchableContext = React.createContext<ILaunchableContext>(
  launchableContextDefaultValues
);

interface Props {
  children: React.ReactNode;
}
const LaunchableContextProvider: React.FC<Props> = ({ children }) => {
  const orgContext = useContext(OrgContext);
  // Calls API to get Launchables for the active Org
  const [activelaunchables, setActiveLaunchables] = useState<
    LaunchableFromList[]
  >([]);
  const [loadingActiveLaunchables, setLoadingActiveLaunchables] =
    useState<boolean>(false);

  const listLaunchables = async (activeOrgId: string) => {
    setLoadingActiveLaunchables(true);
    const list = await agent.Launchables.listLaunchables(activeOrgId);
    if (list.data) {
      setActiveLaunchables(list.data);
    } else {
      setActiveLaunchables([]);
    }
    setLoadingActiveLaunchables(false);
  };

  useEffect(() => {
    if (orgContext.activeOrgId !== "") {
      listLaunchables(orgContext.activeOrgId);
    }
  }, [orgContext.activeOrgId]);

  useEffect(() => {
    document.title = "Launchables | Brev.dev";
  }, []);

  const refreshActiveLaunchables = async () => {
    await listLaunchables(orgContext.activeOrgId);
  };

  const deleteLaunchable = async (
    orgID: string,
    id: string
  ): Promise<AxiosRes & BaseRes> => {
    const res = await agent.Launchables.deleteLaunchable(orgID, id);
    if (res.success) {
      const newLaunchable = activelaunchables.filter((l) => l.id !== id);
      setActiveLaunchables(newLaunchable);
    } else {
      toast.error("Error Deleting Launchable", { description: res.message });
    }
    return res;
  };

  const providerData = {
    activelaunchables,
    loadingActiveLaunchables,
    refreshActiveLaunchables,
    deleteLaunchable,
  };

  return (
    <LaunchableContext.Provider value={providerData}>
      {children}
    </LaunchableContext.Provider>
  );
};

export default LaunchableContextProvider;
